import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface SidingProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Siding: React.FC<SidingProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [siding, setSiding] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Exterior Features']?.['Siding'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Exterior Features': { ...s.values?.['Exterior Features'], Siding: v } } })
    );
    const label = 'Siding';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={siding}
                />
            ) : (
                <TextBox
                    value={siding ?? ''}
                    onChange={(value) => setSiding(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
